import CONFIG from "../config";
//items are ordered initially by their order numbers
let order = CONFIG.getShopConfig({
  edelmetall: "popularity-asc",
  sorten: "popularity-asc",
  default: "name-asc"
});
let kind = "";
let make = "";
let pageSize = 6;
let query = "";

export default {
  setKind: id => {
    kind = id;
  },
  isKindActive: id => {
    return kind === id;
  },
  getKind: () => {
    return kind;
  },
  setMake: id => {
    make = id;
  },
  getMake: () => {
    return make;
  },
  isMakeActive: id => {
    return make === id;
  },
  setOrder: id => {
    order = id;
  },
  getOrder: () => {
    return order;
  },
  isOrderActive: id => {
    return order === id;
  },
  setPageSize: size => {
    pageSize = Number(size) || 0;
  },
  getPageSize: () => {
    return pageSize;
  },
  isPageSizeActive: size => {
    return pageSize === Number(size);
  },
  setQuery: q => {
    query = q;
  },
  getQuery: () => {
    return query;
  },
  isQueryActive: () => {
    return query !== "";
  },
  resetKind: () => {
    kind = "";
  },
  resetMake: () => {
    make = "";
  },
  resetQuery: () => {
    query = "";
  },
  isFiltered: () => {
    return !!kind || !!make;
  }
};
